import React from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { formatMoney } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';

import ViewPopup from './ViewPopup';

const MultiplePopup = ({ decreaseAmountButtonClick, popupRef, profile, multiple, messages }) => {
    const multipleError = useSelector(({ messages }) => messages?.jsMessages['site.js.validation.multiple.error']);
    const errorText = resolveArguments(multipleError, formatMoney(multiple, 0));
    return (
        <ViewPopup
            isShowChangeAmountButton={true}
            isShowGotItButton={false}
            isShowDeliveryOptions={false}
            isShowIncreaseLimitButton={false}
            decreaseAmountButtonClick={decreaseAmountButtonClick}
            popupRef={popupRef}
            errorText={errorText}
            profile={profile}
            messages={messages}
        />
    );
};
MultiplePopup.propTypes = {
    decreaseAmountButtonClick: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    multiple: PropTypes.number,
    profile: PropTypes.object,
    messages: PropTypes.object,
};
export default MultiplePopup;
